import {
  Box,
  VStack,
  HStack,
  Text,
  Badge,
  Icon,
  Center,
  Spinner,
} from '@chakra-ui/react'
import { LuUsers } from 'react-icons/lu'
import { useMyCollaborators } from '../../api/api_hooks/lab/myCollaborators'
import { useTranslation } from 'react-i18next'

/**
 * "Mes collaborateurs" — every person the current user has invited as
 * collaborateur (role='editor'), across ALL their cases, deduplicated by
 * email. Hidden entirely when the user has never invited anyone, so it
 * never shows as an empty card on a brand-new or non-premium account.
 */
export default function CollaboratorsPanel() {
  const { t } = useTranslation()
  const { data: collaborators, isLoading } = useMyCollaborators()

  if (isLoading) {
    return (
      <Box bg="white" borderRadius="2xl" border="1px solid" borderColor="gray.100" boxShadow="sm" p={5}>
        <Center py={2}><Spinner size="sm" color="blue.400" /></Center>
      </Box>
    )
  }

  if (!collaborators || collaborators.length === 0) return null

  return (
    <Box bg="white" borderRadius="2xl" border="1px solid" borderColor="gray.100" boxShadow="sm" p={5}>
      <HStack spacing={2} mb={3}>
        <Icon as={LuUsers} boxSize={4} color="gray.500" />
        <Text fontWeight="700" fontSize="sm" color="gray.800">
          {t('profile.collaborators.title', { count: collaborators.length })}
        </Text>
      </HStack>
      <VStack spacing={2} align="stretch">
        {collaborators.map((c) => (
          <HStack key={c.email} justify="space-between" fontSize="xs" px={1} py={1}>
            <VStack spacing={0} align="start">
              <Text color="gray.700">{c.email}</Text>
              <Text color="gray.400" fontSize="2xs">
                {c.jobTitle ? `${c.jobTitle} · ` : ''}
                {t('profile.collaborators.sharedCases', { count: c.caseCount })}
              </Text>
            </VStack>
            <Badge
              colorScheme={c.status === 'accepted' ? 'green' : 'orange'}
              variant="subtle"
              fontSize="2xs"
            >
              {c.status === 'accepted' ? t('profile.collaborators.active') : t('profile.collaborators.pending')}
            </Badge>
          </HStack>
        ))}
      </VStack>
    </Box>
  )
}
